import React from 'react';
import { LollipopChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildXYChartOptions, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = transformToGroupValue(panelData, chart);
                const colorScale = buildColorScale(data);
                const chartOptions = {
                    ...buildXYChartOptions(chart, { bottomMapsTo: 'group' }),
                    resizable: true,
                    data: { groupMapsTo: 'group' },
                    color: { scale: colorScale }
                };
                return <LollipopChart options={chartOptions} data={data} />;
            }}
        </ChartPanelWrapper>
    );
};

export default React.memo(Index);
